import { render, staticRenderFns } from "./GestionNovedadesModal.vue?vue&type=template&id=20c50642&scoped=true"
import script from "./GestionNovedadesModal.vue?vue&type=script&lang=js"
export * from "./GestionNovedadesModal.vue?vue&type=script&lang=js"
import style0 from "./GestionNovedadesModal.vue?vue&type=style&index=0&id=20c50642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c50642",
  null
  
)

export default component.exports